import { useParams, useNavigate } from "react-router-dom";
import useInterviewQuestions from "../hooks/useInterviewQuestions";
import "./AdminSelectInterviewQuestionScreen.css";

export default function AdminSelectInterviewQuestionScreen() {
    const { domainId, categoryId, packId, interviewId } = useParams();
    const navigate = useNavigate();

    const {
        questions,
        selectedIds,
        selectedQuestions,
        loading,
        toggleQuestion,
        updateOrderId,
    } = useInterviewQuestions(domainId, categoryId, packId, interviewId);

    const handleBack = () => navigate(-1);

    return (
        <div className="interview-home-page">
            <div className="header-row">
                <h2>Interview Questions</h2>
                <button className="back-btn" onClick={handleBack}>
                    ← Back
                </button>
            </div>

            {loading ? (
                <p className="info-text">Loading questions...</p>
            ) : questions.length === 0 ? (
                <p className="info-text">No questions found.</p>
            ) : (
                <ul className="question-list">
                    {questions.map((q) => {
                        const isSelected = selectedIds.has(q.id);
                        const orderId = selectedQuestions?.[q.id]?.orderId ?? "";

                        return (
                            <li
                                key={q.id}
                                className={`question-item ${isSelected ? "selected" : ""}`}
                                onClick={() => toggleQuestion(q.id)}
                            >
                                <div className="question-main">
                                    <div className="question-text">
                                        {q.questionNumber ? (
                                            <span className="q-num">{q.questionNumber}. </span>
                                        ) : null}

                                        {/* ✅ Render code-style formatting if looks like coding */}
                                        {q.question?.includes("class ") ||
                                            q.question?.includes("def ") ||
                                            q.question?.includes("{") ||
                                            q.question?.includes("function ") ||
                                            q.question?.includes("=>") ? (
                                            <pre className="code-question">
                                                <code>{q.question}</code>
                                            </pre>
                                        ) : (
                                            <strong>{q.question}</strong>
                                        )}
                                    </div>
                                </div>

                                {isSelected && (
                                    <div
                                        className="order-id"
                                        onClick={(e) => e.stopPropagation()} // prevent toggle on input click
                                    >
                                        <label>Order:</label>
                                        <input
                                            type="number"
                                            value={orderId}
                                            onChange={(e) => updateOrderId(q.id, e.target.value)}
                                            className="order-input"
                                            min="0"
                                        />
                                    </div>
                                )}
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
}
